"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactorySerialNumberStructFromString = exports.IncrementalFromString = exports.DayOfMonthFromString = exports.MonthNumberFromCode = exports.YearFromCode = exports.ColorFromCode = exports.TechnologyStructFromCode = exports.WaterTypesFromCode = exports.SizeFromCode = exports.ModelFromCode = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../../schema");
const Sku = __importStar(require("./sku"));
const Technology = __importStar(require("./technology"));
const Water = __importStar(require("./water"));
const NAMESPACE = 'Culligan.Device.Class.Gbfc.FactorySerialNumber';
exports.ModelFromCode = effect_1.Schema.transformLiterals(...[
    ['BR', 'BR'],
    ['BS', 'BR2'],
    ['XS', 'BR2FX'],
    ['XR', 'BRFX'],
    ['XT', 'BTFX'],
    ['GD', 'GD'],
    ['XD', 'GDFX'],
])
    .pipe(effect_1.Schema.compose(Sku.ModelFromCode))
    .annotations({
    identifier: `${NAMESPACE}.ModelFromCode`,
});
exports.SizeFromCode = effect_1.Schema.transformLiterals(...[
    ['1', 'FS'],
    ['2', 'M'],
    ['3', 'MU'],
    ['4', 'FT'],
])
    .pipe(effect_1.Schema.compose(Sku.SizeFromCode))
    .annotations({
    identifier: `${NAMESPACE}.SizeFromCode`,
});
exports.WaterTypesFromCode = effect_1.Schema.transformLiterals(...[
    ['C2', 'CA'],
    ['C3', 'CAS'],
    ['H2', 'HC'],
    ['H3', 'HCA'],
    ['H6', 'HCAS'],
])
    .pipe(effect_1.Schema.compose(Water.TypesFromOption))
    .annotations({
    identifier: `${NAMESPACE}.WaterTypesFromCode`,
});
exports.TechnologyStructFromCode = effect_1.Schema.transformLiterals(...[
    ['E2', 'HBK111NX'],
    ['E7', 'HBL111NX'],
    ['B9', 'HED661TX'],
    ['B3', 'HVD661TX'],
    ['C7', 'IBD660TX'],
    ['AS', 'NAK110NX'],
    ['C8', 'NDK110NX'],
    ['B7', 'NDK111NX'],
    ['C9', 'NEK110NX'],
    ['C2', 'NEK111NX'],
    ['AY', 'PAP660TX'],
    ['C6', 'PCD660TX'],
])
    .pipe(effect_1.Schema.compose(Technology.TechnologyStructFromCode))
    .annotations({
    identifier: `${NAMESPACE}.TechnologyStructFromCode`,
});
exports.ColorFromCode = Sku.ColorFromCode.annotations({
    identifier: `${NAMESPACE}.ColorFromCode`,
});
const MIN_YEAR = 2_000;
const MAX_YEAR = 2_099;
exports.YearFromCode = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^\d{2}$/), effect_1.Schema.compose((0, schema_1.EncodePadStart)(2, '0')), effect_1.Schema.compose(effect_1.Schema.NumberFromString), effect_1.Schema.between(0, 99), effect_1.Schema.transform(effect_1.Schema.Number, {
    decode: yearCode => MIN_YEAR + yearCode,
    encode: year => year - MIN_YEAR,
}), effect_1.Schema.filter(year => year >= MIN_YEAR && year <= MAX_YEAR)).annotations({
    identifier: `${NAMESPACE}.YearFromCode`,
});
exports.MonthNumberFromCode = effect_1.Schema.transformLiterals(...[
    ['A', 1],
    ['B', 2],
    ['C', 3],
    ['D', 4],
    ['E', 5],
    ['F', 6],
    ['G', 7],
    ['H', 8],
    ['I', 9],
    ['J', 10],
    ['K', 11],
    ['L', 12],
]).annotations({
    identifier: `${NAMESPACE}.MonthNumberFromCode`,
});
exports.DayOfMonthFromString = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^\d{2}$/), effect_1.Schema.compose((0, schema_1.EncodePadStart)(2, '0')), effect_1.Schema.compose(effect_1.Schema.NumberFromString), effect_1.Schema.between(1, 31)).annotations({
    identifier: `${NAMESPACE}.DayOfMonthFromString`,
});
exports.IncrementalFromString = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^\d{3}$/), effect_1.Schema.compose((0, schema_1.EncodePadStart)(3, '0')), effect_1.Schema.compose(effect_1.Schema.NumberFromString), effect_1.Schema.between(1, 999)).annotations({
    identifier: `${NAMESPACE}.IncrementalFromString`,
});
const FactorySerialNumberPatternStruct = effect_1.Schema.Struct({
    model: exports.ModelFromCode,
    size: exports.SizeFromCode,
    waterTypes: exports.WaterTypesFromCode,
    technology: exports.TechnologyStructFromCode,
    color: exports.ColorFromCode,
    year: exports.YearFromCode,
    monthNumber: exports.MonthNumberFromCode,
    dayOfMonth: exports.DayOfMonthFromString,
    incremental: exports.IncrementalFromString,
}).annotations({ identifier: `${NAMESPACE}.FactorySerialNumberPatternStruct` });
exports.FactorySerialNumberStructFromString = (0, schema_1.CapturePattern)(/^(?<model>[A-Z]{2})(?<size>[1-4])(?<waterTypes>[A-Z]\d)(?<technology>[A-Z]\d)(?<color>[A-Z]{2})(?<year>\d{2})(?<monthNumber>[A-L])(?<dayOfMonth>\d{2})(?<incremental>\d{3})$/, FactorySerialNumberPatternStruct, ({ model, size, waterTypes, technology, color, year, monthNumber, dayOfMonth, incremental }) => effect_1.Effect.succeed([model, size, waterTypes, technology, color, year, monthNumber, dayOfMonth, incremental].join('')))
    .pipe(effect_1.Schema.transform(effect_1.Schema.typeSchema(FactorySerialNumberPatternStruct).pipe(effect_1.Schema.omit('year', 'monthNumber', 'dayOfMonth'), effect_1.Schema.extend(effect_1.Schema.Struct({ manufacturedAt: effect_1.Schema.ValidDateFromSelf }))), {
    strict: true,
    decode: ({ year, monthNumber, dayOfMonth, ...fields }) => ({
        ...fields,
        manufacturedAt: new Date(year, monthNumber - 1, dayOfMonth, 0, 0, 0, 0),
    }),
    encode: ({ manufacturedAt, ...fields }) => ({
        ...fields,
        year: manufacturedAt.getFullYear(),
        monthNumber: (manufacturedAt.getMonth() + 1),
        dayOfMonth: manufacturedAt.getDate(),
    }),
}))
    .annotations({
    identifier: `${NAMESPACE}.FactorySerialNumberStructFromString`,
});
//# sourceMappingURL=factory-serial-number.js.map